import React, { FC, useState, useEffect, useRef } from 'react'
import {
  Container,
  LogoImg,
  ArrowCloseContainer,
  ArrowCloseImg,
  CategoryHeader,
  CategoryBadge,
} from './styles'
import { useTheme } from 'styled-components'
import { useAuth } from '../../context/user.context'

import HomeIcon from './icons/home-default.svg'
import HomeHoverIcon from './icons/home-hover.svg'
import InstanceIcon from './icons/instances-default.svg'
import InstanceHoverIcon from './icons/instances-hover.svg'
import VolumesIcon from './icons/volumes-default.svg'
import VolumesHoverIcon from './icons/volumes-hover.svg'
import ImagesIcon from './icons/images-default.svg'
import ImagesHoverIcon from './icons/images-hover.svg'
import SSHKeysIcon from './icons/ssh-keys-default.svg'
import SSHKeysHoverIcon from './icons/ssh-keys-hover.svg'
import NetworksIcon from './icons/network-default.svg'
import NetworksHoverIcon from './icons/network-hover.svg'
import KubernetesIcon from './icons/kubernetes-default.svg'
import KubernetesHoverIcon from './icons/kubernetes-hover.svg'
import SecurityIcon from './icons/security-group-default.svg'
import SecurityHoverIcon from './icons/security-group-hover.svg'
import BalancersIcon from './icons/load-balancer-default.svg'
import BalancersHoverIcon from './icons/load-balancer-hover.svg'
import FloatingIcon from './icons/floating-ip-default.svg'
import FloatingHoverIcon from './icons/floating-ip-hover.svg'
import BillingIcon from './icons/billing-default.svg'
import BillingHoverIcon from './icons/billing-hover.svg'
import SupportIcon from './icons/support-default.svg'
import SupportHoverIcon from './icons/support-hover.svg'
import RouterIcon from './icons/router-default.svg'
import RouterHoverIcon from './icons/router-hover.svg'
import PortIcon from './icons/port-default.svg'
import PortHoverIcon from './icons/port-hover.svg'
import ObjStoreIcon from './icons/obj-store-ic.svg'
import ObjStoreHoverIcon from './icons/obj-store-hover-ic.svg'
import OperationsIcon from './icons/operations-default.svg'
import OperationsHoverIcon from './icons/operations-hover.svg'
import AffiliateIcon from './icons/affiliate-default.svg'
import BareMetalIcon from './icons/bare-metal.svg'
import BareMetalHoverIcon from './icons/bare-metal-hover.svg'

// New icons - exact keys from backend API
import GroupIcon from './icons/group-default.svg'
import GroupHoverIcon from './icons/group-hover.svg'
import RuleIcon from './icons/rule-default.svg'
import RuleHoverIcon from './icons/rule-hover.svg'
import EmailIcon from './icons/email-default.svg'
import EmailHoverIcon from './icons/email-hover.svg'
import FolderIcon from './icons/folder-default.svg'
import FolderHoverIcon from './icons/folder-hover.svg'
import DatabaseIcon from './icons/database-default.svg'
import DatabaseHoverIcon from './icons/database-hover.svg'
import ShareIcon from './icons/share-default.svg'
import ShareHoverIcon from './icons/share-hover.svg'
import DnsZonesIcon from './icons/dns-zones-default.svg'
import DnsZonesHoverIcon from './icons/dns-zones-hover.svg'
import SubnetpoolsIcon from './icons/subnetpools-default.svg'
import SubnetpoolsHoverIcon from './icons/subnetpools-hover.svg'
import KeysIcon from './icons/keys-default.svg'
import KeysHoverIcon from './icons/keys-hover.svg'
import DnsIcon from './icons/dns-default.svg'
import DnsHoverIcon from './icons/dns-hover.svg'
import FlavorsIcon from './icons/flavors-default.svg'
import FlavorsHoverIcon from './icons/flavors-hover.svg'
import ClientsIcon from './icons/clients-default.svg'
import ClientsHoverIcon from './icons/clients-hover.svg'
import UsersIcon from './icons/users-default.svg'
import UsersHoverIcon from './icons/users-hover.svg'
import InvoiceItemIcon from './icons/invoice-item-default.svg'
import InvoiceItemHoverIcon from './icons/invoice-item-hover.svg'
import ServicesIcon from './icons/services-default.svg'
import ServicesHoverIcon from './icons/services-hover.svg'
import JournalIcon from './icons/journal-default.svg'
import JournalHoverIcon from './icons/journal-hover.svg'
import GatewaysIcon from './icons/gateways-default.svg'
import GatewaysHoverIcon from './icons/gateways-hover.svg'
import ProductIcon from './icons/products-default.svg'
import ProductHoverIcon from './icons/products-hover.svg'
import TaxRulesIcon from './icons/tax-rules-default.svg'
import TaxRulesHoverIcon from './icons/tax-rules-hover.svg'
import ShoppingCartIcon from './icons/shopping-cart-default.svg'
import ShoppingCartHoverIcon from './icons/shopping-cart-hover.svg'
import ActivityLogIcon from './icons/activity-log-default.svg'
import ActivityLogHoverIcon from './icons/activity-log-hover.svg'
import SettingsIcon from './icons/settings-default.svg'
import SettingsHoverIcon from './icons/settings-hover.svg'
import TiledGridIcon from './icons/tiled-grid-default.svg'
import TiledGridHoverIcon from './icons/tiled-grid-hover.svg'
import NotificationsIcon from './icons/notifications-default.svg'
import NotificationsHoverIcon from './icons/notifications-hover.svg'
import OpenstackIcon from './icons/openstack-default.svg'
import OpenstackHoverIcon from './icons/openstack-hover.svg'
import OpenstackPlansIcon from './icons/openstack-plans-default.svg'
import OpenstackPlansHoverIcon from './icons/openstack-plans-hover.svg'
import RulerIcon from './icons/ruler-default.svg'
import RulerHoverIcon from './icons/ruler-hover.svg'
import TodoIcon from './icons/todo-default.svg'
import TodoHoverIcon from './icons/todo-hover.svg'

import { useTranslation } from 'react-i18next'
import SideBarTab from '../side-bar-item'
import ArrowClose from './icons/arrowClose.svg'
import { useUi } from '../../context/ui.context'
import { useLocation, useNavigate } from 'react-router'
import LogoSmall from './logo-cube.svg'
import LogoSmallDark from './logo-cube.svg'
import LogoDark from './logo-white.svg'
import Logo from './logo-black.svg'
import {
  authService,
  floatingIpService,
  imageService,
  instanceService,
  loadBalancerService,
  networkService,
  routerService,
  securityService,
  volumeService,
} from '../../api'
import TopProgress from '../TopBarProgress'
import { useSpring, animated } from '@react-spring/web';
import styled from 'styled-components';

const Answer:any = styled(animated.div)`
  overflow: hidden;
`;

const LEGACY_HIDDEN_PAGES_KEY = 'ocp_hidden_sidebar_pages'

const normalizeRoute = (route?: string | null) => {
  if (!route) return ''
  const routeWithSlash = route.startsWith('/') ? route : `/${route}`
  return routeWithSlash.replace(/\/+$/, '') || '/'
}

const routePrefixByFirstSegment: Record<string, string> = {
  clients: 'clients-users',
  users: 'clients-users',
  'user-groups': 'clients-users',
  'client-groups': 'clients-users',
  roles: 'clients-users',
  'mass-message': 'clients-users',
  overview: 'billing',
  services: 'billing',
  invoices: 'billing',
  journal: 'billing',
  gateways: 'billing',
  products: 'billing',
  'configurable-options': 'billing',
  'tax-rules': 'billing',
  referrals: 'billing',
  ukrsib: 'billing',
  'activity-log': 'utilities',
  operations: 'utilities',
  reports: 'utilities',
  'periodic-task-log': 'utilities',
  'email-message-log': 'utilities',
  general: 'settings',
  configurations: 'settings',
  authorization: 'settings',
  'message-templates': 'settings',
  'openstack-plans': 'settings',
  'volume-backups': 'openstack',
  'volume-snapshots': 'openstack',
  'volume-types': 'openstack',
  volumes: 'openstack',
  instances: 'openstack',
  'bare-metal': 'openstack',
  images: 'openstack',
  'floating-ips': 'openstack',
  clusters: 'openstack',
  'cluster-templates': 'openstack',
  'database-instances': 'openstack',
  networks: 'openstack',
  'rbac-policies': 'openstack',
  routers: 'openstack',
  ports: 'openstack',
  zones: 'openstack',
  projects: 'openstack',
  'security-groups': 'openstack',
  'subnet-pools': 'openstack',
  'flavor-groups': 'openstack',
  flavors: 'openstack',
  'ssh-keys': 'openstack',
  hypervisors: 'openstack',
  'api-users': 'openstack',
  'load-balancers': 'openstack',
  'load-balancer-listener': 'openstack',
  'load-balancer-pool': 'openstack',
}

const getReactRoute = (route?: string | null) => {
  if (!route) return ''
  const cleanRoute = route.replace(/^\/+|\/+$/g, '')
  const [firstSegment] = cleanRoute.split('/')
  const knownRoot = ['home', 'not-found', '403', 'account-settings', 'clients-users', 'openstack', 'object-storage', 'billing', 'orders', 'utilities', 'settings']

  if (!cleanRoute || knownRoot.includes(firstSegment)) return cleanRoute

  const prefix = routePrefixByFirstSegment[firstSegment]
  return prefix ? `${prefix}/${cleanRoute}` : cleanRoute
}

const getRouteCheckKey = (route: string) => {
  const cleanRoute = getReactRoute(route).replace(/^\/+|\/+$/g, '')
  const segments = cleanRoute.split('/')
  return ['clients-users', 'openstack', 'billing', 'utilities', 'settings'].includes(segments[0])
    ? segments[1] || segments[0]
    : segments[0]
}

const routeMatches = (pathname: string, route?: string | null) => {
  const target = normalizeRoute(route)
  const current = normalizeRoute(pathname)

  if (!target) return false
  return current === target || current.startsWith(`${target}/`)
}

const getBestActiveRoute = (pathname: string, menu: any) => {
  const routes: string[] = []

  menu?.menu?.forEach((menuItem: any) => {
    if (menuItem.type === 'menuItem') {
      routes.push(getReactRoute(menuItem.angular_route || 'home'))
      return
    }

    if (menuItem.type === 'menuItemContainer') {
      menuItem.items?.forEach((item: any) => {
        if (item.angular_route) {
          routes.push(getReactRoute(item.angular_route))
        }
      })
    }
  })

  return routes
    .filter((route) => routeMatches(pathname, route))
    .sort((first, second) => normalizeRoute(second).length - normalizeRoute(first).length)[0]
}

// Icon mapping — keys match exact "icon" field values from backend get_app_menu
const iconMap: { [key: string]: { default: string; hover: string } } = {
  // Original icons
  dashboard: { default: HomeIcon, hover: HomeHoverIcon },
  instances: { default: InstanceIcon, hover: InstanceHoverIcon },
  volumes: { default: VolumesIcon, hover: VolumesHoverIcon },
  images: { default: ImagesIcon, hover: ImagesHoverIcon },
  networks: { default: NetworksIcon, hover: NetworksHoverIcon },
  routers: { default: RouterIcon, hover: RouterHoverIcon },
  ports: { default: PortIcon, hover: PortHoverIcon },
  security_groups: { default: SecurityIcon, hover: SecurityHoverIcon },
  lbaas: { default: BalancersIcon, hover: BalancersHoverIcon },
  floating_ip: { default: FloatingIcon, hover: FloatingHoverIcon },
  billing: { default: BillingIcon, hover: BillingHoverIcon },
  support: { default: SupportIcon, hover: SupportHoverIcon },
  operations: { default: OperationsIcon, hover: OperationsHoverIcon },
  affiliate: { default: AffiliateIcon, hover: AffiliateIcon },
  bare_metal: { default: BareMetalIcon, hover: BareMetalHoverIcon },
  dedicated_server: { default: BareMetalIcon, hover: BareMetalHoverIcon },
  dedicated_servers: { default: BareMetalIcon, hover: BareMetalHoverIcon },
  clusters: { default: KubernetesIcon, hover: KubernetesHoverIcon },
  kubernetes: { default: KubernetesIcon, hover: KubernetesHoverIcon },
  obj_store: { default: ObjStoreIcon, hover: ObjStoreHoverIcon },
  perm_media: { default: ObjStoreIcon, hover: ObjStoreHoverIcon },
  sshkeys: { default: KeysIcon, hover: KeysHoverIcon },
  // Exact backend keys
  users: { default: UsersIcon, hover: UsersHoverIcon },
  clients: { default: ClientsIcon, hover: ClientsHoverIcon },
  group: { default: GroupIcon, hover: GroupHoverIcon },
  rule: { default: RuleIcon, hover: RuleHoverIcon },
  email: { default: EmailIcon, hover: EmailHoverIcon },
  folder: { default: FolderIcon, hover: FolderHoverIcon },
  database: { default: DatabaseIcon, hover: DatabaseHoverIcon },
  share: { default: ShareIcon, hover: ShareHoverIcon },
  dns_zones: { default: DnsZonesIcon, hover: DnsZonesHoverIcon },
  subnetpools: { default: SubnetpoolsIcon, hover: SubnetpoolsHoverIcon },
  keys: { default: KeysIcon, hover: KeysHoverIcon },
  dns: { default: DnsIcon, hover: DnsHoverIcon },
  flavors: { default: FlavorsIcon, hover: FlavorsHoverIcon },
  memory: { default: FlavorsIcon, hover: FlavorsHoverIcon },
  journal: { default: JournalIcon, hover: JournalHoverIcon },
  gateways: { default: GatewaysIcon, hover: GatewaysHoverIcon },
  invoice_item: { default: InvoiceItemIcon, hover: InvoiceItemHoverIcon },
  services: { default: ServicesIcon, hover: ServicesHoverIcon },
  product: { default: ProductIcon, hover: ProductHoverIcon },
  tax_rules: { default: TaxRulesIcon, hover: TaxRulesHoverIcon },
  referrals: { default: AffiliateIcon, hover: AffiliateIcon },
  shopping_cart: { default: ShoppingCartIcon, hover: ShoppingCartHoverIcon },
  add_shopping_cart: { default: ShoppingCartIcon, hover: ShoppingCartHoverIcon },
  supervisor_account: { default: GroupIcon, hover: GroupHoverIcon },
  activity_log: { default: ActivityLogIcon, hover: ActivityLogHoverIcon },
  settings: { default: SettingsIcon, hover: SettingsHoverIcon },
  tiled_grid: { default: TiledGridIcon, hover: TiledGridHoverIcon },
  notifications: { default: NotificationsIcon, hover: NotificationsHoverIcon },
  openstack: { default: OpenstackIcon, hover: OpenstackHoverIcon },
  openstack_plans: { default: OpenstackPlansIcon, hover: OpenstackPlansHoverIcon },
  cluster_settings: { default: KubernetesIcon, hover: KubernetesHoverIcon },
  ruler: { default: RulerIcon, hover: RulerHoverIcon },
  todo: { default: TodoIcon, hover: TodoHoverIcon },
}

// Override icons by feature key (when backend sends wrong icon like "folder" for clusters)
const featureIconOverride: { [key: string]: { default: string; hover: string } } = {
  'kubernetes.clusters': { default: KubernetesIcon, hover: KubernetesHoverIcon },
  'kubernetes.cluster_settings': { default: KubernetesIcon, hover: KubernetesHoverIcon },
  'openstack.plans': { default: OpenstackPlansIcon, hover: OpenstackPlansHoverIcon },
  'dedicatedservers.servers': { default: BareMetalIcon, hover: BareMetalHoverIcon },
  'dedicated_servers.servers': { default: BareMetalIcon, hover: BareMetalHoverIcon },
  'dedicatedservers.users': { default: UsersIcon, hover: UsersHoverIcon },
  'dedicated_servers.users': { default: UsersIcon, hover: UsersHoverIcon },
  'dedicatedservers.ips': { default: FloatingIcon, hover: FloatingHoverIcon },
  'dedicated_servers.ips': { default: FloatingIcon, hover: FloatingHoverIcon },
}

// Map category names to their representative icons (for collapsed sidebar)
const categoryIconMap: { [key: string]: { default: string; hover: string } } = {
  'clients & users': { default: ClientsIcon, hover: ClientsHoverIcon },
  'cloud': { default: InstanceIcon, hover: InstanceHoverIcon },
  'billing': { default: BillingIcon, hover: BillingHoverIcon },
  'orders': { default: ShoppingCartIcon, hover: ShoppingCartHoverIcon },
  'utilities': { default: ActivityLogIcon, hover: ActivityLogHoverIcon },
  'settings': { default: SettingsIcon, hover: SettingsHoverIcon },
  'todo': { default: TodoIcon, hover: TodoHoverIcon },
  'clusters': { default: KubernetesIcon, hover: KubernetesHoverIcon },
  'openstack': { default: OpenstackIcon, hover: OpenstackHoverIcon },
}

const SideBar: FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { appMenu, user } = useAuth()
  const { setSmallBar, smallBar } = useUi()
  const [loadingNav, setLoadingNav] = useState<boolean>(false)
  const [activeText, setActiveText] = useState<boolean>(false)
  const [openCategories, setOpenCategories] = useState<{ [key: string]: boolean }>({})
  const theme: any = useTheme()
  const location = useLocation()
  const activeRoute = React.useMemo(
    () => getBestActiveRoute(location.pathname, appMenu),
    [appMenu, location.pathname]
  )
  const isPathActive = React.useCallback((path?: string | null) => {
    return normalizeRoute(path) === normalizeRoute(activeRoute)
  }, [activeRoute]);

  useEffect(() => {
    localStorage.removeItem(LEGACY_HIDDEN_PAGES_KEY)
  }, [])

  useEffect(() => {
    if (!smallBar) {
      const timeout = setTimeout(() => {
        setActiveText(true)
      }, 150)
      return () => clearTimeout(timeout)
    } else {
      setActiveText(false)
    }
  }, [smallBar])

  const changeSizeBar = () => {
    setSmallBar(!smallBar)
  }

  const toggleCategory = (category: string) => {
    setOpenCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }))
  }

  const checkMenu = async (url: string) => {
    switch (url) {
      case 'instances':
        return await instanceService.getInstanceList({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      case 'volumes':
        return await volumeService.getVolumeList({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      case 'images':
        return await imageService.getImagesList({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      case 'networks':
        return await networkService.getAllNetworks({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      case 'routers':
        return await routerService.getRouters({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      case 'security-groups':
        return await securityService.getSecurityList({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      case 'floating-ips':
        return await floatingIpService.getIps({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      case 'load-balancers':
        return await loadBalancerService.getList({
          page: 1,
          ordering: '',
          pageSize: 10,
        })
      default:
        return await authService.getUser()
    }
  }

  const checkClient = async (route: string, navigateTo: string) => {
    setLoadingNav(true)
    try {
      await checkMenu(getRouteCheckKey(navigateTo))
      await navigate(navigateTo)
    } catch (err: any) {
      return false
    } finally {
      setLoadingNav(false)
    }
  }
  return (
    <Container data-test-id="sidebar-container" active={smallBar}>
      <TopProgress loading={loadingNav} />
      <ArrowCloseContainer active={smallBar} onClick={changeSizeBar}>
        <ArrowCloseImg active={smallBar} src={ArrowClose} />
      </ArrowCloseContainer>
      <LogoImg
        onClick={() => {
          window.open('https://onecloudplanet.com/')
        }}
        active={!activeText}
        src={
          theme.isDark
            ? !activeText
              ? LogoSmallDark
              : LogoDark
            : !activeText
            ? LogoSmall
            : Logo
        }
      />
      {appMenu?.menu?.map((menuItem: any, index: number) => {
        if (menuItem.type === 'menuItem') {
          const icons = featureIconOverride[menuItem.feature] || iconMap[menuItem.icon] || {
            default: HomeIcon,
            hover: HomeHoverIcon,
          }
          return (
            <SideBarTab
              key={menuItem.angular_route || menuItem.feature}
              href={menuItem.angular_route ? `/${getReactRoute(menuItem.angular_route)}` : '/home'}
              isFirst={index === 0}
              isSmall={smallBar}
              active={isPathActive(getReactRoute(menuItem.angular_route || 'home'))}
              defaultIcon={icons.default}
              hoverIcon={icons.hover}
              title={menuItem.label.replace(/ /g, '_')}
              activeText={activeText}
              onClick={() =>
                menuItem.angular_route
                  ? checkClient(
                      menuItem.angular_route,
                      `/${getReactRoute(menuItem.angular_route)}`
                    )
                  : navigate('/home')
              }
            />
          )
        } else if (menuItem.type === 'menuItemContainer') {
          return (
            <ItemContainer
              key={menuItem.category}
              menuItem={menuItem}
              openCategories={openCategories}
              activeText={activeText}
              toggleCategory={toggleCategory}
              smallBar={smallBar}
              checkClient={checkClient}
              isPathActive={isPathActive}
            />
          )
        }
        return null
      })}
    </Container>
  )
}

export default SideBar


const ItemContainer:FC<any> = ({menuItem, openCategories, activeText, toggleCategory, smallBar, checkClient, isPathActive}) => {
  const answerRef:any = React.useRef(null);
  const navigate = useNavigate()
  const { t } = useTranslation()

  const animatedStyles = useSpring({
    from: { height: 0 },
    to: {
      height: openCategories[menuItem.category]  ? answerRef?.current?.scrollHeight : 0,
    },
  });

  const location = useLocation()
  const isBillingCategory = menuItem.category?.toLowerCase()?.includes('billing')

  return(
    <div key={menuItem.category}>
      <CategoryHeader
        active={!activeText}
        isOpen={openCategories[menuItem.category]}
        onClick={() => {
          toggleCategory(menuItem.category)
        }}
      >
        {!activeText ? (
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            {(() => {
              const catIcon = categoryIconMap[menuItem.category?.toLowerCase()] || { default: HomeIcon, hover: HomeIcon }
              return <img src={catIcon.default} alt="" style={{ width: 20, height: 20, opacity: 0.7 }} />
            })()}
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
              <span className="category-title">
                {menuItem.category}
              </span>
              <CategoryBadge>{menuItem.items.length}</CategoryBadge>
            </div>
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              style={{
                transform: openCategories[menuItem.category] ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: '0.2s transform ease-in-out',
                flexShrink: 0,
                opacity: 0.6,
              }}
            >
              <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
            </svg>
          </>
        )}
      </CategoryHeader>

        <Answer ref={answerRef} style={animatedStyles}>
          {menuItem.items.map((item: any) => {
            const icons = featureIconOverride[item.feature] || iconMap[item.icon] || {
              default: null,
              hover: null,
            }
            return (
              <SideBarTab
                key={item.angular_route || item.feature}
                href={`/${getReactRoute(item.angular_route)}`}
                isSmall={smallBar}
                active={isPathActive(getReactRoute(item.angular_route))}
                defaultIcon={icons.default}
                hoverIcon={icons.hover}
                icon={item?.icon}
                title={item.label.replace(/ /g, '_')}
                activeText={activeText}
                onClick={() =>
                  checkClient(item.angular_route, `/${getReactRoute(item.angular_route)}`)
                }
              />
            )
          })}

          {/* Custom Ukrsib menu item for Billing category */}
          {isBillingCategory && (
            <SideBarTab
              key="ukrsib"
              href="/billing/ukrsib"
              isSmall={smallBar}
              active={location.pathname?.includes('/billing/ukrsib')}
              defaultIcon={BillingIcon}
              hoverIcon={BillingHoverIcon}
              title={t('UKRSIB')}
              activeText={activeText}
              onClick={() => navigate('/billing/ukrsib')}
            />
          )}
        </Answer>
    </div>
  )
}
